<template>
  <v-list
    class="user-menu__menu"
  >
    <v-list-item>
      <v-list-item-title>
        {{ greeting }}, <b>{{ user.name }}</b>
      </v-list-item-title>

      <v-spacer />
    </v-list-item>

    <v-divider />

    <StUserMenuListItem
      v-for="(item) in items"
      :key="item.name"
      :icon="item.icon"
      :text="item.name"
      @click="$emit('menu-list-item-clicked', item)"
    />

    <v-divider />

    <StUserMenuListItem
      icon="file-document-box-check"
      :text="termsOfUse"
      @click="$emit('terms-clicked')"
    />

    <StUserMenuListItem
      icon="shield-check"
      :text="privacyPolicy"
      @click="$emit('privacy-policy-clicked')"
    />

    <v-divider />

    <StUserMenuListItem
      icon="exit-to-app"
      :text="logoutLabel"
      @click="$emit('logout-item-clicked')"
    />
  </v-list>
</template>

<script>
import StUserMenuListItem from './StUserMenuListItem';

export default {
  name: 'StUserMenuList',
  components: {
    StUserMenuListItem,
  },
  props: {
    greeting: {
      type: String,
      required: true,
    },
    logoutLabel: {
      type: String,
      default: 'Logout',
    },
    termsOfUse: {
      type: String,
      default: 'Termos de uso',
    },
    privacyPolicy: {
      type: String,
      default: 'Política de privacidade',
    },
    user: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style scoped>
  .user-menu__menu {
    width: 250px;
  }
</style>
